<template lang="pug">
.question-list
  app-header.header

  //- パンくずリスト
  ul.breadcrumb
    li
      router-link(to="/") {{ $t('Home') }}
    li
      router-link(to="/safety_confirmations") {{ $t('Safety Confirmation List') }}
    li.active
      span {{ $t('Safety Confirmation Answer List') }}

  .row.margin-top
    .col-sm-12
      div
        .form-inline
          select.form-control(v-model="searchShop" :disabled="!isSystemManagement")
            option(:value="undefined")
            template(v-for="shop in shops")
              option(:value="shop.id") {{shop.attributes['shop-name']}}
          select.form-control.margin-left(v-model="searchStatus")
            option(value="")
            option(value="yet") 未確認
            option(value="safety") 家族全員無事
            option(value="notSafety") 家族全員無事以外
          div.search-form-check
            input(v-model="searchCanHelp", type='checkbox',id="search-can-help")
            label.small.margin-left(for="search-can-help") 出社可能
          input.form-control.margin-left(type="text", placeholder="氏名", v-model="searchUser")
          button.btn.btn-info.margin-left(v-on:click="search(false)")
            i.fa.fa-search
            span 検索

  .row.margin-top
    .col-sm-12.text-right 家族全員無事: {{ safetyCount }}件&nbsp;報告件数: {{ alertCount }}件&nbsp;/&nbsp;{{ targetCount }}件

  div
    div(v-if="searchEnd && safetyConfirmationAnswers.length > 0")
      .row.margin-top
        //- 一覧表示
        .table-responsive
          table.table.table-condensed()
            //- 表示ヘッダ
            thead
              tr.info
                th.col-sm-1 店舗名 
                th.col-sm-2 氏名
                th.col-sm-1 安否状態
                th.col-sm-1 
                th.col-sm-1 開封日時
                th.col-sm-1 報告日時
                th.col-sm-4 報告コメント
            tbody
              tr(v-for="(safetyConfirmationAnswer,index) in safetyConfirmationAnswers")
                td {{ safetyConfirmationAnswer.attributes['shop-name'] }}
                td 
                  a(v-on:click="goUser(safetyConfirmationAnswer.attributes['user-id'])") {{ safetyConfirmationAnswer.attributes['name'] }}
                td 
                  span.badge(v-if="safetyConfirmationAnswer.attributes['is-safety']" style='background-color: #1989f0') 家族全員無事
                  span.badge(v-else-if="safetyConfirmationAnswer.attributes['sent-at'] != ''" style='background-color: #ccc') 家族全員無事
                  span.badge(v-else style='background-color: #888') 未確認
                td 
                  span.badge(v-if="safetyConfirmationAnswer.attributes['can-help']" style='background-color: #f8bb00') 出社可能
                  span.badge(v-else-if="safetyConfirmationAnswer.attributes['sent-at'] != ''" style='background-color: #ccc') 出社可能
                td {{ safetyConfirmationAnswer.attributes['confirmed-at'] }}
                td {{ safetyConfirmationAnswer.attributes['sent-at'] }}
                td(style="white-space:pre-wrap;") {{ safetyConfirmationAnswer.attributes['comment'] }}

      //- 更に読み込む
      .row.margin-top(v-if="nextExist")
        .col-xs-12.text-center
          button.btn.btn-default.next-page-search-btn(v-on:click="search(true)")
            i.fa.fa-chevron-down
            =" "
            span {{ $t('Read More') }}

    .row.margin-top(v-if="searchEnd && safetyConfirmationAnswers.length == 0")
      .col-xs-12
        .alert.alert-warning
          i.fa.fa-exclamation-triangle
          =" "
          span {{ $t('No Data') }}

</template>
<script>
var utils = require('../utils')
import AppHeader from './AppHeader'

export default {
  name: 'service-question-answer-list',
  created () {
    this.searchShop = this.$store.getters.safetyConfirmationSearchShop
    this.searchStatus = this.$store.getters.safetyConfirmationSearchStatus || false
    this.searchCanHelp = this.$store.getters.safetyConfirmationSearchCanHelp
    this.searchUser = this.$store.getters.safetyConfirmationSearchUser

    if (!this.isSystemManagement && !this.isShopMaster) {
      this.$router.push({ path: '/' })
    }
    this.getShop()
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      safetyConfirmationAnswers: [],
      searchEnd: false,
      nextExist: false,
      currentPage: 0,
      searchStatus: undefined,
      searchCanHelp: false,
      searchShop: undefined,
      searchUser: undefined,
      targetName: '全体',
      safetyCount: 0,
      alertCount: 0,
      targetCount: 0
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isShopMaster () {
      return localStorage.is_shop_master === '1'
    },
    shops () {
      return this.$store.getters.shopsAll
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function (addSearch) {
      const shop = this.shops.find(shop => shop.id === this.searchShop)
      this.targetName = shop ? shop.attributes['shop-name'] : '全体'

      let data = {
        search_shop: this.searchShop,
        search_status: this.searchStatus,
        search_can_help: this.searchCanHelp,
        search_user: this.searchUser
      }
      if (addSearch) {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
      } else {
        this.searchEnd = false
        this.currentPage = 0
      }
      this.$store.dispatch('GET_SAFETY_CONFIRMATION_ANSWER_LIST', {id: this.$route.params.id, data: data})
      .then(res => {
        if (addSearch && res.answers) {
          this.safetyConfirmationAnswers = this.safetyConfirmationAnswers.concat(res.answers.data)
          this.searchEnd = true
        } else {
          this.safetyConfirmationAnswers = res.answers ? res.answers.data : []
          this.safetyCount = res['safety_count'] || 0
          this.alertCount = res['alert_count'] || 0
          this.targetCount = res['target_count'] || 0
          this.searchEnd = true
        }
        this.nextExist = res.next_exist
      })
      .catch(err => console.log(err))
    },
    goUser: function (userId) {
      this.$router.push({ path: '/users/' + userId, query: {safetyConfirmationId: this.$route.params.id} })
    },
    getShop: function () {
      const self = this
      const callback = function () {
        self.searchCallbackFlag = true
        // 退職者一覧店舗を表示しない
        let workIndex = 0
        for (let i = 0; i < self.shops.length; i++) {
          if (self.shops[i].id === '800') {
            workIndex = i
            break
          }
        }
        if (workIndex !== 0) {
          self.shops.splice(workIndex, 1)
        }
      }

      this.$store.dispatch('SHOP_ALL_GET', {callback: callback})
    }
  }
}
</script>
<style scoped>
.search-form-check {
  display: inline-block;
  margin: 0px 24px
}
</style>


// WEBPACK FOOTER //
// SafetyConfirmationAnswerList.vue?7d42d3ad